import { Carousel } from 'components/carousel/Carousel';
import { ScrollableDocument } from 'components/newAccountSteps/initialStep/documentation/documentsModal/ScrollableDocument';
import React, { useMemo, useState } from 'react';
import { base64ToBlob, downloadAsFile } from 'utilities/APIRequestHelper';
import {
    doTagDownloadDocument,
    doTagPrintDocument,
} from 'components/newAccountSteps/initialStep/documentation/tagging';

export const DocumentsCarousel = ({ documentsList, currentDocumentIndex, pdfContainerRef, onScroll }) => {
    const [showIconsBoxes, setShowIconsBoxes] = useState(documentsList.map(() => false));
    const showIconsBox = useMemo(() => showIconsBoxes[currentDocumentIndex], [showIconsBoxes, currentDocumentIndex]);
    const currentDocumentPdfFile = documentsList[currentDocumentIndex].file;

    const handleDownload = e => {
        e.preventDefault();
        const currentDocument = documentsList[currentDocumentIndex];
        downloadAsFile(base64ToBlob(currentDocumentPdfFile), 'application/pdf', `${currentDocument.documentName}.pdf`);
        doTagDownloadDocument(currentDocument);
    };

    const handlePrintPdf = e => {
        e.preventDefault();
        const blob = new Blob([base64ToBlob(currentDocumentPdfFile)], {
            type: 'application/pdf',
        });
        const blobURL = window.URL.createObjectURL(blob);
        const noLocationWithScrollAndMenu = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,';
        const pdfWindowSize = 'resizable,screenX=50,screenY=50,width=850,height=1050';
        const pdfWindowParams = noLocationWithScrollAndMenu + pdfWindowSize;
        const pdfWindow = window.open(blobURL, '', pdfWindowParams);
        pdfWindow.print();
        doTagPrintDocument(documentsList[currentDocumentIndex]);
    };
    const handleScroll = ({ documentIndex, hasScrolledToBottom, hasScrolledOutsideOfDocumentActions }) => {
        if (hasScrolledToBottom) {
            !showIconsBox &&
                setShowIconsBoxes(prevState => prevState.map((show, index) => (index === documentIndex ? true : show)));
            onScroll({ documentIndex, isAtBottom: true });
        } else {
            if (showIconsBox && hasScrolledOutsideOfDocumentActions) {
                setShowIconsBoxes(prevState =>
                    prevState.map((show, index) => (index === documentIndex ? false : show))
                );
            }
            onScroll({ documentIndex, isAtBottom: false });
        }
    };

    return (
        <div className={`documents__modal-body ${showIconsBox && 'with-icons-box'}`} role="article">
            <Carousel activeIndex={currentDocumentIndex} className={`documents__modal-pdf-viewer`}>
                {documentsList.map((document, index) => (
                    <ScrollableDocument
                        key={`document_${document.documentType}`}
                        documentIndex={index}
                        pdfContainerRef={pdfContainerRef}
                        file={document.file}
                        onScrollChange={handleScroll}
                    />
                ))}
            </Carousel>
            {showIconsBox && (
                <div className="documents__modal-icons">
                    <button onClick={handlePrintPdf}>
                        <i className={`icons icons--icon-print-blue`} />
                    </button>
                    <button onClick={handleDownload}>
                        <i className={`icons icons--icon-download-blue`} />
                    </button>
                </div>
            )}
        </div>
    );
};
